import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Skeleton,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import "./paymentLinks.css";
import { useNavigate } from "react-router";
import Timer from "../../reusableComponents/Timer";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import FileCopyIcon from "../../../assets/svg/fileCopy.svg";
import { colorBrandObject } from "../../../constants/brandings";
import { fileCopyDefaultColor } from "../../reusableComponents/constants";

export default function AccordionPaymentLink({ data, timeZone }) {
  const [expanded, setExpanded] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    if (data?.length > 0) {
      setLoading(false);
    }
  }, [data]);

  const handleCopy = ({ transactionDetails }) => {
    navigator.clipboard.writeText(transactionDetails);
    customToast("success", "medium", "Copied to clipboard");
  };
  return (
    <>
      {loading ? (
        Array.from({ length: 4 }).map((_, idx) => (
          <div key={idx} style={{ marginTop: "20px" }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={60}
              style={{ marginBottom: 10, borderRadius: "6px" }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={40}
              style={{ marginBottom: 10 }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={40}
              style={{ marginBottom: 10 }}
            />
          </div>
        ))
      ) : (
        <div className="accordionDiv">
          {data?.length > 0 &&
            data?.map((item, idx) => {
              const panelId = `panel${idx}`;
              return (
                <Accordion
                  key={idx}
                  expanded={expanded === panelId}
                  onChange={handleChange(panelId)}
                  className="paymentLinkAccordion expandIcon summaryContent"
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        style={{
                          display: expanded === panelId ? "none" : "block",
                          marginBottom: expanded === panelId ? "0px" : "6px",
                        }}
                      />
                    }
                    aria-controls={`${panelId}-content`}
                    id={`${panelId}-header`}
                  >
                    <div style={{ width: "100%", padding: "10px 0px 0px 0px" }}>
                      <div className="titleDiv">
                        <div>
                          <Typography className="labelMedium font-black-medium">
                            Title:
                          </Typography>
                          <Typography
                            className="bodyB2Medium font-black-high"
                            style={{
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {item?.title}
                          </Typography>
                        </div>

                        <Typography className="labelMedium">
                          {item?.status === "PAID" && (
                            <div
                              className="statusDiv"
                              style={{
                                backgroundColor: "#D5FBD2",
                                color: "#0B6A48",
                              }}
                            >
                              {item?.status}
                            </div>
                          )}
                          {item?.status === "PENDING" && (
                            <div
                              className="statusDiv"
                              style={{
                                backgroundColor: "#FBEFCB",
                                color: "#9E5707",
                              }}
                            >
                              {item?.status}
                            </div>
                          )}
                          {item?.status === "EXPIRED" && (
                            <div
                              className="statusDiv"
                              style={{
                                backgroundColor: "#FDE3D6",
                                color: "#B9232F",
                              }}
                            >
                              {item?.status}
                            </div>
                          )}
                          {item?.status === "FAILED" && (
                            <div
                              className="statusDiv"
                              style={{
                                backgroundColor: "#FDE3D6",
                                color: "#B9232F",
                              }}
                            >
                              {item?.status}
                            </div>
                          )}
                          {item?.status === "PROCESSING" && (
                            <div
                              className="statusDiv"
                              style={{
                                backgroundColor: "#FBEFCB",
                                color: "#9E5707",
                              }}
                            >
                              {item?.status}
                            </div>
                          )}
                        </Typography>
                      </div>
                      {item?.status === "PENDING" && (
                        <>
                          <Divider />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            <Typography className="labelMedium font-black-medium">
                              Expires In:
                            </Typography>
                            <Typography className="labelSemiBold font-black-high">
                              {
                                <Timer
                                  timeZone={timeZone}
                                  timeStamp={item?.sessionExpiryTimestamp}
                                />
                              }
                            </Typography>
                          </div>
                        </>
                      )}
                      <Divider />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <Typography className="labelMedium font-black-medium">
                          Amount:
                        </Typography>
                        <Typography className="labelSemiBold font-black-high">
                          {item?.amountLocale}
                        </Typography>
                      </div>
                      <Divider />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "10px",
                        }}
                      >
                        <Typography className="labelMedium font-black-medium">
                          Payment Link:
                        </Typography>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Typography className="labelSemiBold font-black-high paymentUrl">
                            {item?.paymentUrl}
                          </Typography>
                          <div style={{ stroke: fileCopyDefaultColor }}>
                            <FileCopyIcon stroke={`${colorBrandObject?.primaryButtonColor}`}
                              style={{ marginLeft: "4px", cursor: "pointer" }}
                              onClick={() =>
                                handleCopy({
                                  transactionDetails: item?.paymentUrl,
                                })
                              }
                            />
                          </div>
                          {/* <img
                            src="/assets/fileCopy.svg"
                            alt="copy"
                            style={{ marginLeft: "4px", cursor: "pointer" }}
                            onClick={() =>
                              handleCopy({
                                transactionDetails: item?.paymentUrl,
                              })
                            }
                          /> */}
                        </div>
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails style={{ marginTop: "-10px" }}>
                    {item?.addedTimestamp && (
                      <>
                        <Divider style={{ margin: "10px 16px" }} />
                        <div className="detailsContent">
                          <Typography className="labelMedium font-black-medium">
                            Created At:
                          </Typography>
                          <Typography className="labelSemiBold font-black-high">
                            {item?.addedTimestamp}
                          </Typography>
                        </div>
                      </>
                    )}
                    {item?.lastPaidAtTimestamp && (
                      <>
                        <Divider style={{ margin: "10px 16px" }} />
                        <div className="detailsContent">
                          <Typography className="labelMedium font-black-medium">
                            Paid At:
                          </Typography>
                          <Typography className="labelSemiBold font-black-high">
                            {item?.lastPaidAtTimestamp}
                          </Typography>
                        </div>
                      </>
                    )}
                    {item?.latestTransactionId && (
                      <>
                        <Divider style={{ margin: "10px 16px" }} />
                        <div className="detailsContent">
                          <Typography className="labelMedium font-black-medium">
                            Transaction Id:
                          </Typography>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Typography className="labelSemiBold font-black-high paymentUrl">
                              {item?.latestTransactionId}
                            </Typography>

                            <img
                              src="/assets/externalFile.svg"
                              alt="empty"
                              style={{ marginLeft: "4px", cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  "/transacs/payment_details/transaction_Details?transactionId=" +
                                  item?.latestTransactionId
                                )
                              }
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {item?.productName && (
                      <>
                        <Divider style={{ margin: "10px 16px" }} />

                        <div className="detailsContent">
                          <Typography className="labelMedium font-black-medium">
                            Product Name:
                          </Typography>
                          <Typography className="labelSemiBold font-black-high">
                            {item?.productName}
                          </Typography>
                        </div>
                      </>
                    )}
                    {item?.userId && (
                      <>
                        <Divider style={{ margin: "10px 16px" }} />

                        <div className="detailsContent">
                          <Typography className="labelMedium font-black-medium">
                            Created By:
                          </Typography>
                          <Typography className="labelSemiBold font-black-high">
                            {item?.userId}
                          </Typography>
                        </div>
                      </>
                    )}
                    {item?.shopper?.phoneNumber && (
                      <>
                        <Divider style={{ margin: "10px 16px" }} />

                        <div className="detailsContent">
                          <Typography className="labelMedium font-black-medium">
                            Cutomer Mobile:
                          </Typography>
                          <Typography className="labelSemiBold font-black-high">
                            {item?.shopper?.phoneNumber}
                          </Typography>
                        </div>
                      </>
                    )}
                    {item?.shopper?.email && (
                      <>
                        <Divider style={{ margin: "10px 16px" }} />
                        <div className="detailsContent">
                          <Typography className="labelMedium font-black-medium">
                            Email:
                          </Typography>
                          <Typography className="labelSemiBold font-black-high">
                            {item?.shopper?.email}
                          </Typography>
                        </div>
                      </>
                    )}
                    {expanded ? (
                      <div className="expandIconContainerBottom">
                        <ExpandLessIcon
                          className="expanded"
                          onClick={() => setExpanded(!expanded)}
                        />
                      </div>
                    ) : (
                      <div className="expandIconContainerTop">
                        <ExpandMoreIcon className="collapsed" />
                      </div>
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            })}
        </div>
      )}
    </>
  );
}
